// const i18nReducer =
import { i18nActions } from '@common/store/i18n/actions/i18n.actions';
import { defaultI18n } from '@common/utils/i18n.default';
import { populateI18n } from '@common/utils/util';
import { createReducer, on } from '@ngrx/store';
import { I18NState } from '@src/suite/common/store/i18n/models/i18n.models';

export const initialState: I18NState = {
    i18n: defaultI18n,
};

export const i18nReducer = createReducer(
    initialState,
    on(i18nActions.initializeI18n, (state, { data }) => {
        return {
            ...state,
            i18n: populateI18n(data, state.i18n),
        };
    })
);
